<template>
    <div class="animated fadeIn">

        <table class="table">
            <tr>
                <td>
                    {{Core.Definition.getDefinition('Sujet')}}
                </td>
                <td>
                    {{dataTicket.subject}}
                </td>
            </tr>
            <tr>
                <td colspan="2">
                    {{dataTicket.description}}
                </td>
            </tr>
        </table>

        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/support/ticket"
                saveRoot="/support/ticket"
                @onInitSuccess="onInitSuccess"
                @onTrashClick="onTrashClick">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/support/ticket"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression du billet de support')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer ce billet de support?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../../components/DynamicForm'
    import ModalTrash from '../../../components/ModalTrash'
    export default {
        name: 'Ticket',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataTicket: {
                    subject: '',
                    description: ''
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push(Core.Definition.getDefinition('/systeme/support/billets'))
            },
            onInitSuccess(data) {
                if (data.form !== undefined) {
                    this.dataTicket = data.form
                }
            }
        }
    }
</script>
